import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../router/types';

/**
 * InvitationError view - Redirects to /invite with error flag
 * This maintains compatibility for /invite-error URLs while showing errors inline (SRS redirects to this path)
 */
function InvitationError() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to /invite with error state
    const searchParams = new URLSearchParams(location.search);

    navigate(`${ROUTES.INVITATION_ACCEPT}?${searchParams.toString()}`, {
      replace: true,
      state: { hasError: true },
    });
  }, [navigate, location.search]);

  // Return null as this component only handles redirection
  return null;
}

export default InvitationError;
